import * as React from "react"

function SvgComponent(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={449.376}
      height={337.842}
      viewBox="0 0 449.376 337.842"
      {...props}
    >
      <g data-name="Asset 3">
        <g data-name="Layer 2">
          <g data-name="Group 466">
            <path
              data-name="Path 9220"
              d="M433.047 242.941a29.272 29.272 0 01-1.191-10.093c.985-15.114 13.135-26.664 16.178-41.266 2.954-14.238 1.152-30.366-10.152-40.617-15.626-14.159-40.193-12.613-51.32-32.611-9.965-17.911-7.789-39.573-18.649-57.493-10.231-16.851-26.605-28.358-43.827-37.22C299.145 10.733 270.187-.384 241.809.01c-32.237.463-55.239 22.361-76.8 43.63-19 18.708-52.472 17.025-42.724 65.4 8.694 43.078-11.816 39.878-30.573 55.79s-32.444 34.807-24.992 56.292c8.212 23.71-42.1 37.308-51.074 68.019-6.095 20.835 25.876 22.6 47.637 22.6s207.918-1.772 286.65.7c21.711.679 42.537 1.369 64.14-1.28 9.167-1.132 18.521-3.505 25.729-9.275 22.578-18.062-1.113-39.488-6.755-58.945z"
              fill="#c3ecfe"
              opacity={0.35}
            />
          </g>
          <path
            data-name="Path 9221"
            d="M409.484 309.996a75.818 75.818 0 017.2-54.155l.561.315a75.138 75.138 0 00-7.139 53.693z"
            fill="#bae9f4"
          />
          <path
            data-name="Path 9222"
            d="M414.673 260.468a14.08 14.08 0 013.791-9.019 2.836 2.836 0 012.1-1.113.984.984 0 01.6.246 1.182 1.182 0 01.167 1.034 9.58 9.58 0 01-3.033 4.775c-1.378 1.329-2.235 2.511-3.623 4.076"
            fill="#bae9f4"
          />
          <path
            data-name="Path 9223"
            d="M412.182 266.77a14.12 14.12 0 017.06-6.774 2.865 2.865 0 012.363-.2.985.985 0 01.463.473 1.182 1.182 0 01-.266.985 9.462 9.462 0 01-4.677 3.18c-1.792.67-3.043 1.418-4.923 2.3"
            fill="#bae9f4"
          />
          <path
            data-name="Path 9224"
            d="M409.612 275.189a14.061 14.061 0 016.174-7.582 2.806 2.806 0 012.314-.482.866.866 0 01.512.414 1.152 1.152 0 01-.128 1.034 9.452 9.452 0 01-4.254 3.722c-1.7.9-2.855 1.782-4.618 2.895"
            fill="#bae9f4"
          />
          <path
            data-name="Path 9225"
            d="M408.253 283.676a14.041 14.041 0 016.184-7.582 2.8 2.8 0 012.314-.482.9.9 0 01.512.414 1.182 1.182 0 01-.128 1.034 9.423 9.423 0 01-4.264 3.722c-1.694.9-2.846 1.782-4.618 2.895"
            fill="#bae9f4"
          />
          <path
            data-name="Path 9226"
            d="M407.899 295.079a14.061 14.061 0 015.357-8.182 2.816 2.816 0 012.255-.719.876.876 0 01.551.354 1.152 1.152 0 010 1.044 9.443 9.443 0 01-3.84 4.145c-1.6 1.063-2.649 2.068-4.293 3.358"
            fill="#bae9f4"
          />
          <path
            data-name="Path 9227"
            d="M408.44 303.369a15.064 15.064 0 014.677-8.31 3.141 3.141 0 012.107-1.044.748.748 0 01.542.217.985.985 0 010 .985 10.615 10.615 0 01-3.446 4.411c-1.457 1.241-2.412 2.334-3.938 3.781"
            fill="#bae9f4"
          />
          <path
            data-name="Path 9228"
            d="M411.217 269.714a15.213 15.213 0 01-4.6-9.157 3.111 3.111 0 01.453-2.462.984.984 0 01.581-.325 1.152 1.152 0 01.9.561 10.389 10.389 0 011.792 5.681c.167 2.028.542 3.515.876 5.7"
            fill="#bae9f4"
          />
          <path
            data-name="Path 9229"
            d="M409.455 276.291a15.233 15.233 0 01-6.656-7.789 3.141 3.141 0 01-.148-2.5.906.906 0 01.482-.453 1.172 1.172 0 01.985.325 10.466 10.466 0 013.1 5.1c.64 1.92 1.359 3.279 2.215 5.317"
            fill="#bae9f4"
          />
          <path
            data-name="Path 9230"
            d="M408.214 285.045a15.233 15.233 0 01-8.074-6.3 3.151 3.151 0 01-.65-2.422.906.906 0 01.384-.542 1.162 1.162 0 011.054.118 10.427 10.427 0 014.047 4.372 54.654 54.654 0 003.24 4.776"
            fill="#bae9f4"
          />
          <path
            data-name="Path 9231"
            d="M407.712 296.388a15.193 15.193 0 01-6.479-7.946 3.111 3.111 0 01-.1-2.491.916.916 0 01.492-.453 1.191 1.191 0 01.985.354 10.4 10.4 0 012.954 5.16c.6 1.969 1.29 3.308 2.1 5.376"
            fill="#bae9f4"
          />
          <path
            data-name="Path 9232"
            d="M408.627 304.433a15.2 15.2 0 01-9.354-4.165 3.1 3.1 0 01-1.211-2.2.985.985 0 01.236-.62 1.182 1.182 0 011.054-.138 10.457 10.457 0 014.982 3.269c1.408 1.457 2.649 2.373 4.293 3.85"
            fill="#bae9f4"
          />
          <path
            data-name="Path 9233"
            d="M447.275 310.577c0 1.369-100.129 2.481-223.642 2.481S0 311.946 0 310.577s100.129-2.481 223.632-2.481 223.643 1.093 223.643 2.481z"
            fill="#afe1f2"
          />
          <path
            data-name="Line 226"
            fill="none"
            stroke="#ffc840"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2.99}
            d="M242.587 22.342V43.66"
          />
          <path
            data-name="Line 227"
            fill="none"
            stroke="#ffc840"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2.99}
            d="M198.17 30.17l7.286 20.038"
          />
          <path
            data-name="Line 228"
            fill="none"
            stroke="#ffc840"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2.99}
            d="M159.109 52.718l13.706 16.335"
          />
          <path
            data-name="Line 229"
            fill="none"
            stroke="#ffc840"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2.99}
            d="M130.121 87.269l18.462 10.664"
          />
          <path
            data-name="Line 230"
            fill="none"
            stroke="#ffc840"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2.99}
            d="M114.691 129.648l21.002 3.702"
          />
          <path
            data-name="Line 231"
            fill="none"
            stroke="#ffc840"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2.99}
            d="M114.691 174.745l21.002-3.702"
          />
          <path
            data-name="Line 232"
            fill="none"
            stroke="#ffc840"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2.99}
            d="M130.121 217.124l18.462-10.654"
          />
          <path
            data-name="Line 233"
            fill="none"
            stroke="#ffc840"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={3}
            d="M158.715 252.759l13.775-16.414"
          />
          <path
            data-name="Line 234"
            fill="none"
            stroke="#ffc840"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={3}
            d="M197.963 275.405l7.326-20.126"
          />
          <path
            data-name="Line 235"
            fill="none"
            stroke="#ffc840"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={3}
            d="M242.587 283.283v-21.426"
          />
          <path
            data-name="Line 236"
            fill="none"
            stroke="#ffc840"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2.99}
            d="M286.994 274.224l-7.286-20.038"
          />
          <path
            data-name="Line 237"
            fill="none"
            stroke="#ffc840"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2.99}
            d="M326.055 251.675l-13.706-16.335"
          />
          <path
            data-name="Line 238"
            fill="none"
            stroke="#ffc840"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2.99}
            d="M355.043 217.124l-18.462-10.654"
          />
          <path
            data-name="Line 239"
            fill="none"
            stroke="#ffc840"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2.99}
            d="M370.472 174.745l-21.002-3.702"
          />
          <path
            data-name="Line 240"
            fill="none"
            stroke="#ffc840"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2.99}
            d="M370.472 129.648l-21.002 3.702"
          />
          <path
            data-name="Line 241"
            fill="none"
            stroke="#ffc840"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2.99}
            d="M355.043 87.269l-18.462 10.664"
          />
          <path
            data-name="Line 242"
            fill="none"
            stroke="#ffc840"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2.99}
            d="M326.055 52.718l-13.706 16.335"
          />
          <path
            data-name="Line 243"
            fill="none"
            stroke="#ffc840"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2.99}
            d="M286.994 30.17l-7.286 20.038"
          />
          <path
            data-name="Path 9234"
            d="M260.074 310.006c43.541.591 89.6-1.487 133.163-.9 1.467 0 6.223-.394-1.713-5.514-6.725-4.332-27.964-.433-27.964-.433s4.923-1.969 4.923-4.539-1.969-4.815-4.283-5.908a15.913 15.913 0 00-7.542-.985 47.893 47.893 0 00-15.173 3.4 4.4 4.4 0 10-5.1-7.149c3.259-4.421 8.3-24.006-7.2-32.641-19.437-10.831-34.2-1.91-37.348 4.6-1.6-6.39-8.931-11.225-13.785-12.426-11.018-2.737-18.2-1.969-28.476 2.875-3.643 1.7-8.517 7.5-10.93 10.713-3.791 5.012-4.382 11.688-4.588 17.98q-.236 7.08-.059 14.149"
            fill="#bae9f4"
          />
          <path
            data-name="Path 9235"
            d="M71.879 310.065c-20.362.276-41.906-.7-62.269-.423-.679 0-2.9-.187.807-2.58 3.141-1.969 13.076-.2 13.076-.2s-2.314-.926-2.3-2.127a3.249 3.249 0 011.969-2.747 7.473 7.473 0 013.525-.463 22.529 22.529 0 017.089 1.585 2.058 2.058 0 112.393-3.338c-1.526-2.068-3.889-11.225 3.367-15.262 9.078-5.061 15.981-.9 17.458 2.147.748-2.954 4.175-5.248 6.43-5.809 5.16-1.28 8.507-.9 13.322 1.349 1.694.8 3.939 3.505 5.11 5 1.763 2.353 2.038 5.475 2.137 8.409q.118 3.308 0 6.627"
            fill="#bae9f4"
          />
          <path
            data-name="Path 9236"
            d="M130.495 111.551l-11.3 117.173a3.643 3.643 0 01-3.939 3.279l-18.907-1.822a3.663 3.663 0 01-3.279-3.939l11.314-117.173a3.633 3.633 0 013.939-3.279l18.9 1.822a3.643 3.643 0 013.279 3.939z"
            fill="#fdefea"
          />
          <path
            data-name="Path 9237"
            d="M128.004 111.275l-1.969 20.756-21.229-2.048 1.969-20.756a1.191 1.191 0 011.29-1.054l18.954 1.861a1.172 1.172 0 01.985 1.241z"
            fill="#f9a66e"
          />
          <path
            data-name="Rectangle 1215"
            fill="#ffb27e"
            d="M102.47 154.195l2.213-22.944 21.229 2.047-2.214 22.945z"
          />
          <path
            data-name="Rectangle 1216"
            fill="#a9d6d3"
            d="M105.705 131.202l.123-1.23 21.328 2.132-.123 1.23z"
          />
          <path
            data-name="Rectangle 1217"
            fill="#fcbf95"
            d="M100.135 178.365l2.213-22.944 21.229 2.047-2.214 22.945z"
          />
          <path
            data-name="Rectangle 1218"
            fill="#a9d6d3"
            d="M102.351 155.447l.118-1.225 21.229 2.051-.119 1.226z"
          />
          <path
            data-name="Rectangle 1219"
            fill="#ffd2b3"
            d="M97.8 202.545l2.213-22.944 21.229 2.047-2.214 22.945z"
          />
          <path
            data-name="Rectangle 1220"
            fill="#a9d6d3"
            d="M100.025 179.631l.118-1.225 21.229 2.051-.119 1.226z"
          />
          <path
            data-name="Path 9238"
            d="M118.911 205.801l-2.186 22.647a1.162 1.162 0 01-1.27 1.054L96.55 227.68a1.172 1.172 0 01-1.054-1.28l2.186-22.647z"
            fill="#ffe5d4"
          />
          <path
            data-name="Rectangle 1221"
            fill="#a9d6d3"
            d="M98.998 204.062l.123-1.23 21.328 2.132-.123 1.23z"
          />
          <path
            data-name="Rectangle 1222"
            fill="#fdefea"
            d="M103.233 130.955l.123-1.23 26.27 2.626-.123 1.231z"
          />
          <path
            data-name="Rectangle 1223"
            fill="#fdefea"
            d="M100.991 155.241l.123-1.23 26.27 2.626-.123 1.231z"
          />
          <path
            data-name="Rectangle 1224"
            fill="#fdefea"
            d="M97.565 179.394l.118-1.225 26.149 2.527-.119 1.225z"
          />
          <path
            data-name="Rectangle 1225"
            fill="#fdefea"
            d="M95.24 203.568l.118-1.225 26.149 2.527-.119 1.225z"
          />
          <path
            data-name="Path 9239"
            d="M92.074 105.525l27.747 114.376a3.643 3.643 0 01-2.668 4.4l-18.462 4.48a3.653 3.653 0 01-4.4-2.688L66.552 111.718a3.633 3.633 0 012.678-4.382l18.452-4.48a3.643 3.643 0 014.392 2.669z"
            fill="#fdefea"
          />
          <path
            data-name="Path 9240"
            d="M89.672 106.105l4.923 20.264-20.678 5.032-4.922-20.264a1.182 1.182 0 01.866-1.418l18.452-4.48a1.172 1.172 0 011.359.866z"
            fill="#5eafbc"
          />
          <path
            data-name="Rectangle 1226"
            fill="#72c5ce"
            d="M74.148 132.615l20.726-5.026 5.432 22.402-20.726 5.026z"
          />
          <path
            data-name="Rectangle 1227"
            fill="#a9d6d3"
            d="M73.879 131.397l20.73-5.033.29 1.196-20.73 5.034z"
          />
          <path
            data-name="Rectangle 1228"
            fill="#93dee2"
            d="M79.886 156.202l20.73-5.033 5.44 22.405-20.73 5.034z"
          />
          <path
            data-name="Rectangle 1229"
            fill="#a9d6d3"
            d="M79.608 154.991l20.73-5.033.29 1.196-20.73 5.034z"
          />
          <path
            data-name="Rectangle 1230"
            fill="#abefef"
            d="M85.599 179.818l20.726-5.026 5.432 22.402-20.726 5.026z"
          />
          <path
            data-name="Rectangle 1231"
            fill="#a9d6d3"
            d="M85.33 178.606l20.73-5.033.29 1.196-20.73 5.034z"
          />
          <path
            data-name="Path 9241"
            d="M112.063 198.396l5.356 22.086a1.162 1.162 0 01-.857 1.418l-18.452 4.48a1.182 1.182 0 01-1.418-.886l-5.356-22.1z"
            fill="#cff9f8"
          />
          <path
            data-name="Rectangle 1232"
            fill="#a9d6d3"
            d="M91.059 202.21l20.73-5.033.29 1.196-20.73 5.034z"
          />
          <path
            data-name="Rectangle 1233"
            fill="#fdefea"
            d="M71.477 131.98l25.534-6.2.291 1.197-25.534 6.2z"
          />
          <path
            data-name="Rectangle 1234"
            fill="#fdefea"
            d="M77.206 155.574l25.534-6.2.291 1.197-25.534 6.2z"
          />
          <path
            data-name="Rectangle 1235"
            fill="#fdefea"
            d="M82.928 179.189l25.534-6.2.291 1.197-25.534 6.2z"
          />
          <path
            data-name="Rectangle 1236"
            fill="#fdefea"
            d="M88.657 202.793l25.534-6.2.291 1.197-25.534 6.2z"
          />
          <path
            data-name="Path 9242"
            d="M62.604 118.433l57.6 102.639a3.643 3.643 0 01-1.388 4.923l-16.552 9.344a3.633 3.633 0 01-4.923-1.388L39.688 131.292a3.653 3.653 0 011.4-4.923l16.562-9.3a3.653 3.653 0 014.954 1.364z"
            fill="#fdefea"
          />
          <path
            data-name="Path 9243"
            d="M60.45 119.644l10.211 18.216-18.6 10.437-10.211-18.216a1.182 1.182 0 01.453-1.6l16.559-9.327a1.162 1.162 0 011.585.492z"
            fill="#ffcd69"
          />
          <path
            data-name="Rectangle 1237"
            fill="#ffd385"
            d="M52.657 149.357l18.599-10.437 11.28 20.102-18.598 10.437z"
          />
          <path
            data-name="Rectangle 1238"
            fill="#a9d6d3"
            d="M52.063 148.258l18.597-10.44.602 1.073-18.596 10.44z"
          />
          <path
            data-name="Rectangle 1239"
            fill="#ffdca4"
            d="M64.544 170.538l18.599-10.437 11.28 20.102-18.598 10.437z"
          />
          <path
            data-name="Rectangle 1240"
            fill="#a9d6d3"
            d="M63.948 169.459l18.599-10.437.602 1.073-18.599 10.438z"
          />
          <path
            data-name="Rectangle 1241"
            fill="#ffe8c7"
            d="M76.426 191.728l18.599-10.437 11.28 20.102-18.598 10.437z"
          />
          <path
            data-name="Rectangle 1242"
            fill="#a9d6d3"
            d="M75.845 190.627l18.597-10.44.602 1.073-18.596 10.44z"
          />
          <path
            data-name="Path 9244"
            d="M106.923 202.463l11.126 19.821a1.172 1.172 0 01-.433 1.6l-16.562 9.3a1.182 1.182 0 01-1.6-.453L88.323 212.9z"
            fill="#fff3e3"
          />
          <path
            data-name="Rectangle 1243"
            fill="#a9d6d3"
            d="M87.721 211.816l18.599-10.437.602 1.073-18.599 10.438z"
          />
          <path
            data-name="Rectangle 1244"
            fill="#fdefea"
            d="M49.891 149.488l22.91-12.856.602 1.073-22.91 12.857z"
          />
          <path
            data-name="Rectangle 1245"
            fill="#fdefea"
            d="M61.792 170.664l22.907-12.86.603 1.073-22.907 12.86z"
          />
          <path
            data-name="Rectangle 1246"
            fill="#fdefea"
            d="M73.678 191.854l22.91-12.856.602 1.073-22.91 12.857z"
          />
          <path
            data-name="Rectangle 1247"
            fill="#fdefea"
            d="M85.555 213.035l22.91-12.856.602 1.073-22.91 12.857z"
          />
          <path
            data-name="Path 9245"
            d="M99.725 299.342c-33.832-22.233-58.694-56.991-68.216-95.333l1.329-.335c9.433 38.017 34.088 72.48 67.625 94.526z"
            fill="#bae9f4"
          />
          <path
            data-name="Path 9246"
            d="M35.165 214.2a30.2 30.2 0 01-7.286-19.693c0-1.753.266-3.7 1.625-4.815a2.019 2.019 0 011.329-.492 2.531 2.531 0 011.763 1.369c2.2 3.476 2.452 7.818 2.255 11.924s.2 7.217.315 11.7"
            fill="#bae9f4"
          />
          <path
            data-name="Path 9247"
            d="M40.518 227.719a30.16 30.16 0 011.113-20.934c.7-1.6 1.723-3.289 3.407-3.761a1.969 1.969 0 011.408.059 2.56 2.56 0 011.083 1.969c.64 4.067-.857 8.153-2.668 11.816s-2.678 6.7-4.342 10.831"
            fill="#bae9f4"
          />
          <path
            data-name="Path 9248"
            d="M48.887 244.646a30.13 30.13 0 01-1.457-20.943c.492-1.674 1.3-3.476 2.954-4.155a1.969 1.969 0 011.408-.108 2.531 2.531 0 011.31 1.822c1.054 3.948.069 8.173-1.241 12.111s-1.831 6.971-2.954 11.314"
            fill="#bae9f4"
          />
          <path
            data-name="Path 9249"
            d="M59.177 259.957a30.1 30.1 0 01-1.458-20.934c.5-1.684 1.3-3.486 2.954-4.155a1.969 1.969 0 011.408-.108 2.471 2.471 0 011.31 1.812c1.132 3.939.148 8.192-1.191 12.082s-1.841 6.971-2.954 11.3"
            fill="#bae9f4"
          />
          <path
            data-name="Path 9250"
            d="M75.345 278.34a30.16 30.16 0 01-3.624-20.674c.325-1.723.985-3.594 2.471-4.441a1.969 1.969 0 011.388-.246 2.521 2.521 0 011.5 1.664c1.536 3.82.985 8.133.059 12.141s-1.1 7.129-1.792 11.56"
            fill="#bae9f4"
          />
          <path
            data-name="Path 9251"
            d="M88.372 290.48a32.139 32.139 0 01-4.923-19.87c.128-1.743.5-3.682 1.753-4.736a1.615 1.615 0 011.172-.443c.67.069 1.122.758 1.428 1.428 1.654 3.545 1.556 7.877 1.083 11.963s-.266 7.227-.512 11.658"
            fill="#bae9f4"
          />
          <path
            data-name="Path 9252"
            d="M43.324 233.746a32.612 32.612 0 01-20.678-7.582c-1.428-1.182-2.855-2.708-2.9-4.51a1.969 1.969 0 01.423-1.369 2.511 2.511 0 012.235-.453c4.214.63 7.877 3.367 11.136 6.292s6.006 4.7 9.748 7.621"
            fill="#bae9f4"
          />
          <path
            data-name="Path 9253"
            d="M50.221 246.644a32.69 32.69 0 01-21.863-2.446c-1.664-.817-3.417-1.969-3.939-3.692a1.969 1.969 0 01.089-1.428 2.521 2.521 0 012.058-.985c4.244-.394 8.5 1.379 12.318 3.446s7 3.151 11.333 5.1"
            fill="#bae9f4"
          />
          <path
            data-name="Path 9254"
            d="M61.116 262.162a32.66 32.66 0 01-21.9 1.969c-1.8-.453-3.771-1.221-4.559-2.826a1.969 1.969 0 01-.194-1.417c.226-.738 1.054-1.123 1.822-1.359 4.076-1.241 8.6-.354 12.8.906s7.444 1.684 12.072 2.727"
            fill="#bae9f4"
          />
          <path
            data-name="Path 9255"
            d="M76.901 280.634a32.641 32.641 0 01-21.761-2.958c-1.644-.847-3.377-2.019-3.811-3.771a1.969 1.969 0 01.118-1.428 2.491 2.491 0 012.078-.926c4.254-.3 8.458 1.566 12.239 3.722s6.893 3.289 11.166 5.327"
            fill="#bae9f4"
          />
          <path
            data-name="Path 9256"
            d="M90.262 291.869a32.709 32.709 0 01-20.776 7.208c-1.851 0-3.939-.3-5.1-1.664a1.9 1.9 0 01-.532-1.319c0-.778.748-1.349 1.438-1.763 3.663-2.186 8.261-2.412 12.6-2.2s7.631-.158 12.367-.266"
            fill="#bae9f4"
          />
          <path
            data-name="Line 244"
            fill="none"
            stroke="#3e89cc"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={3}
            d="M350.307 233.017l-12.712 76.911"
          />
          <path
            data-name="Line 245"
            fill="none"
            stroke="#3e89cc"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={3}
            d="M381.855 233.017l12.712 76.911"
          />
          <path
            data-name="Rectangle 1248"
            fill="#3e89cc"
            d="M305.161 152.797h125.966v91.808H305.161z"
          />
          <path
            data-name="Rectangle 1249"
            fill="#eefbff"
            d="M310.084 156.391h116.119v84.64H310.084z"
          />
          <path
            data-name="Line 246"
            fill="none"
            stroke="#3e89cc"
            strokeMiterlimit={10}
            strokeWidth={3}
            d="M343.168 276.193h45.825"
          />
          <text
            transform="rotate(.573 -20094.701 35325.774)"
            fill="#3e89cc"
            fontSize={18}
            fontFamily="SegoeUI, Segoe UI"
          >
            <tspan x={0} y={0}>
              {"idea"}
            </tspan>
          </text>
          <path
            data-name="Path 9257"
            d="M139.633 310.006H67.34L55.199 179.274a2.668 2.668 0 012.334-3.121h91.907a2.668 2.668 0 012.334 3.121z"
            fill="#81d9fc"
          />
          <path
            data-name="Path 9258"
            d="M211.098 283.883v26.29H79.382a5.534 5.534 0 01-5.534-5.49v-19a5.387 5.387 0 01.3-1.792z"
            fill="#2775af"
          />
          <path
            data-name="Path 9259"
            d="M211.098 283.883v22.814H74.232a5.494 5.494 0 01-.384-2.014v-19a5.387 5.387 0 01.3-1.792z"
            fill="#fff"
          />
          <path
            data-name="Rectangle 1250"
            fill="#c3ecfe"
            d="M73.848 286.522h150.936v1.447H73.848z"
          />
          <path
            data-name="Rectangle 1251"
            fill="#c3ecfe"
            d="M73.848 289.781h150.936v1.447H73.848z"
          />
          <path
            data-name="Rectangle 1252"
            fill="#c3ecfe"
            d="M73.848 293.04h150.936v1.447H73.848z"
          />
          <path
            data-name="Rectangle 1253"
            fill="#c3ecfe"
            d="M73.848 296.3h150.936v1.447H73.848z"
          />
          <path
            data-name="Rectangle 1254"
            fill="#c3ecfe"
            d="M73.848 299.559h150.936v1.457H73.848z"
          />
          <path
            data-name="Rectangle 1255"
            fill="#c3ecfe"
            d="M73.848 302.818h150.936v1.457H73.848z"
          />
          <path
            data-name="Path 9260"
            d="M176.055 282.84h-5.721v16.217l5.721-4.707 5.721 4.707V285.2z"
            fill="#595959"
            opacity={0.2}
          />
          <path
            data-name="Path 9261"
            d="M176.882 281.52l-5.731 2.363v13.864l5.731-4.707 5.721 4.707v-13.864z"
            fill="#ff8736"
          />
          <path
            data-name="Path 9262"
            d="M211.098 280.132v3.751H74.144a5.514 5.514 0 015.238-3.751z"
            fill="#2775af"
          />
          <path
            data-name="Path 9263"
            d="M220.62 254.049v26.29H88.9a5.494 5.494 0 01-5.14-3.505 5.357 5.357 0 01-.394-2.028v-19a5.376 5.376 0 01.329-1.757z"
            fill="#3e89cc"
          />
          <path
            data-name="Path 9264"
            d="M220.619 254.049v22.814H83.754a5.356 5.356 0 01-.394-2.028v-19a5.376 5.376 0 01.335-1.786z"
            fill="#fff"
          />
          <path
            data-name="Rectangle 1256"
            fill="#c3ecfe"
            d="M83.37 256.658h150.936v1.447H83.37z"
          />
          <path
            data-name="Rectangle 1257"
            fill="#c3ecfe"
            d="M83.37 259.917h150.936v1.447H83.37z"
          />
          <path
            data-name="Rectangle 1258"
            fill="#c3ecfe"
            d="M83.37 263.176h150.936v1.447H83.37z"
          />
          <path
            data-name="Rectangle 1259"
            fill="#c3ecfe"
            d="M83.37 266.426h150.936v1.457H83.37z"
          />
          <path
            data-name="Rectangle 1260"
            fill="#c3ecfe"
            d="M83.37 269.685h150.936v1.467H83.37z"
          />
          <path
            data-name="Rectangle 1261"
            fill="#c3ecfe"
            d="M83.37 272.944h150.936v1.467H83.37z"
          />
          <path
            data-name="Path 9265"
            d="M103.821 253.251l-5.721-.729v16.956l5.721-4.707 5.721 4.707v-13.864z"
            fill="#595959"
            opacity={0.2}
          />
          <path
            data-name="Path 9266"
            d="M105.091 251.656l-5.721 2.363v13.867l5.721-4.707 5.721 4.707v-13.867z"
            fill="#ffc840"
          />
          <path
            data-name="Path 9267"
            d="M220.62 250.258v3.791H83.695a5.524 5.524 0 015.228-3.761z"
            fill="#3e89cc"
          />
          <path
            data-name="Path 9268"
            d="M415.077 199.539a.709.709 0 00.64-.7.729.729 0 00-1.447 0 .709.709 0 00.532.679c-.492 3.692-4.923 6.587-10.417 6.676h-.501c-5.455-.089-9.925-2.954-10.418-6.676a.7.7 0 00.532-.679.719.719 0 10-1.438 0 .709.709 0 00.63.7c.423 3.2 3.692 5.819 8.015 6.656h-7.6a.709.709 0 00-.689-.571.719.719 0 100 1.438.709.709 0 00.689-.571h20.057a.709.709 0 00.689.571.719.719 0 100-1.438.709.709 0 00-.689.571h-6.6c4.333-.837 7.592-3.456 8.015-6.656z"
            fill="#3e89cc"
          />
          <path
            data-name="Path 9269"
            d="M409.878 198.544l-5.7 7.8-.414-10.831a2.166 2.166 0 10-1.541-.624 2.156 2.156 0 001.541.624l-.1 10.831s-3.87-5.465-5.908-8.045c.906-2.481 1.969-9.364 2.275-11.648.079-.463.118-.738.118-.738h7.493a2.457 2.457 0 00.079.738c.493 4.016 2.157 11.893 2.157 11.893z"
            fill="#71606e"
          />
          <path
            data-name="Path 9270"
            d="M407.751 186.649h-7.739c.079-.463.118-.738.118-.738h7.513c.049.2.069.482.108.738z"
            fill="#71606e"
            opacity={0.2}
          />
          <path
            data-name="Path 9271"
            d="M409.13 183.154v2.265a.768.768 0 01-.768.778h-9.108a.778.778 0 01-.768-.719v-2.324a.768.768 0 01.768-.768h9.108a.768.768 0 01.768.768z"
            fill="#ff8736"
          />
          <path
            data-name="Path 9272"
            d="M409.13 183.154v2.265a.768.768 0 01-.768.778h-9.108a.778.778 0 01-.768-.719c7.513.443 7.326-2.176 7.04-3.092h2.836a.768.768 0 01.768.768z"
            fill="#71606e"
            opacity={0.2}
          />
          <path
            data-name="Path 9273"
            d="M278.487 273.357v6.292a7.06 7.06 0 01-7.05 7.05H209.07a7.06 7.06 0 01-7.05-7.021v-6.271a7.05 7.05 0 017.05-7.05h62.367a7.05 7.05 0 017.05 7z"
            fill="#71606e"
          />
          <path
            data-name="Path 9274"
            d="M278.487 297.156v6.23a7.06 7.06 0 01-7.05 7.06H209.07a7.07 7.07 0 01-7.05-7.06v-6.23a7.06 7.06 0 017.05-7.06h62.367a7.06 7.06 0 017.05 7.06z"
            fill="#71606e"
          />
          <path
            data-name="Path 9275"
            d="M333.628 152.906a90.97 90.97 0 01-20.1 57.168 88.721 88.721 0 01-9.718 10.358 90.7 90.7 0 01-14.862 11.049 42.576 42.576 0 00-20.874 33.291c0 .5-.059.985-.079 1.536h-55.479a45.963 45.963 0 00-7.3-23.09 49.451 49.451 0 00-3.328-4.618 46.367 46.367 0 00-9.846-9.275 91.306 91.306 0 01-41.2-75.749c-.345-49.981 40.124-91.345 90.1-92.035a92.637 92.637 0 0110.368.433 91.4 91.4 0 0182.318 90.932z"
            fill="#ffc840"
          />
          <path
            data-name="Rectangle 1262"
            fill="#443a43"
            d="M208.164 286.502h64.169v3.604h-64.169z"
          />
          <path
            data-name="Path 9276"
            d="M333.627 152.905a91.345 91.345 0 01-44.683 78.575 44.073 44.073 0 00-21.18 34.659q-27.511.433-55.042 0a47.361 47.361 0 00-7.316-22.361c24.951-3.18 50.04-10.329 70.107-25.483 39.09-29.539 41.818-81.834 16.217-121.446a96.15 96.15 0 00-40.439-34.905 91.4 91.4 0 0182.336 90.961z"
            fill="#ffb839"
            opacity={0.2}
          />
          <path
            data-name="Path 9277"
            d="M278.487 273.357v6.292a7.06 7.06 0 01-7.05 7.05H209.07a7.06 7.06 0 01-7.05-7.021c47.4 4.785 52.107-9.285 52.5-13.322h16.916a7.05 7.05 0 017.05 7z"
            fill="#71606e"
            opacity={0.2}
          />
          <path
            data-name="Path 9278"
            d="M278.487 297.156v6.23a7.06 7.06 0 01-7.05 7.06H209.07a7.06 7.06 0 01-6.893-5.681c57.572 4.923 47.45-14.671 47.45-14.671h21.83a7.06 7.06 0 017.03 7.062z"
            fill="#71606e"
            opacity={0.2}
          />
          <g
            data-name="Group 467"
            opacity={0.5}
            fill="none"
            stroke="#ffe1b0"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={16}
          >
            <path
              data-name="Path 9279"
              d="M180.869 110.615c-7.877 12.3-13.785 30.524-11.737 57.277"
            />
            <path
              data-name="Path 9280"
              d="M209.473 86.974a48.936 48.936 0 00-14.149 7.88"
            />
          </g>
          <path
            data-name="Path 9281"
            d="M131.814 182.356a2.344 2.344 0 011.388 1.723 2.294 2.294 0 01-.738 2.078 1.26 1.26 0 01.985 1.438 3.161 3.161 0 01-.985 1.694 2.875 2.875 0 01-1.969 1.122 2.2 2.2 0 01-1.477-.64 2.737 2.737 0 01-.679-.985 4.529 4.529 0 01-.246-1.31c-.138-1.566-.266-3.131-.4-4.7a1.152 1.152 0 01.187-.906"
            fill="#0b0b3a"
          />
          <path
            data-name="Path 9282"
            d="M118.315 192.695c-.1 2.038 0 5.583-.542 6.1s-4.677.5-4.677.5 8.941 8.438 9.541 7.976 8.557-6.952 6.764-7.286-3.535-.256-3.486-1.182.108-1.851.158-2.777"
            fill="#ed9c80"
          />
          <path
            data-name="Path 9283"
            d="M110.658 238.097s13.115 1.487 16.138 1.546 2.865-1.507 2.865-1.507c.158-3.328.719-11.166 1.339-13.785.591-2.481.847-3.4 1.349-5.75 1.132-5.238 1.083-6.233 2.275-12.692l-7.828-6.3a4.136 4.136 0 01-4.1 2.452c-4.392.059-5.76-3.023-5.76-3.023l-10.683 7.1-.985 17.261 4.027 13.184"
            fill="#0094bc"
          />
          <path
            data-name="Path 9284"
            d="M118.158 190.854a23.131 23.131 0 00.926 3.013 3.417 3.417 0 003.623 2.491l4.017.1a4.618 4.618 0 003.131-.66c.827-.719.847-1.969.985-2.954.236-1.26.423-2.54.571-3.82a56.962 56.962 0 00.354-7.552 5.906 5.906 0 00-.089-1.034.689.689 0 00-.177-.384.807.807 0 00-.482-.187 40.767 40.767 0 00-7.592-.482 8.576 8.576 0 00-5.11 1.359c-1.428 1.1-2.107 2.895-2.718 4.6-.1.266-.167.63.069.8"
            fill="#ed9c80"
          />
          <path
            data-name="Path 9285"
            d="M146.874 282.288a28.094 28.094 0 01-.758 3.387c-.335.867-3.161.069-3.348-.492s.886-4.657.886-4.657"
            fill="#ed9c80"
          />
          <path
            data-name="Path 9286"
            d="M141.788 285.901c-.246.926-.551 2.708-.551 2.708l2.826 1.231.463-.433a5.278 5.278 0 001.566 1.25 12.022 12.022 0 002.737.758c2.471.266 4.283-.2 4.431-.542.61-1.428-2.659-1.812-3.308-1.969a4.332 4.332 0 01-3.1-3.111c-.148-.748 0-.876-.384-.857a.984.984 0 00-.7.335 1.8 1.8 0 01-1.969.463 2.048 2.048 0 01-.985-.837 1.241 1.241 0 00-1.026 1.004z"
            fill="#3a3a3a"
          />
          <path
            data-name="Path 9287"
            d="M134.375 249.342c4.421.866 9.768 1.516 14.238.926-.63 1.782-1.969 3.5-2.54 6.016-1.969 8.33-2.6 19.506-3.082 26.428 0 0 .926 1.772 3.879.423 4.431-10.939 12.16-33.084 12.082-37.9-.089-6.115-15.36-7.592-26.585-9.1"
            fill="#243a6c"
          />
          <g data-name="Group 468">
            <path
              data-name="Path 9288"
              d="M114.868 237.092c-3.515 2.57 19.506 12.249 19.506 12.249a38.075 38.075 0 007.552.719 5.749 5.749 0 00.561-1.428c.128-.67.059-1.359.177-2.038a4.736 4.736 0 012.3-3.1 10.417 10.417 0 013.761-1.211 50.76 50.76 0 018.547-.158c-6.893-5.1-20.382-3.939-26.979-4.362-1.256 2.077-14.923-1.045-15.425-.671z"
              fill="#40536d"
              opacity={0.5}
            />
          </g>
          <g data-name="Group 469">
            <path
              data-name="Path 9289"
              d="M144.91 284.622c-.1.532-.236 1.2-.374 1.743h.128c.423 0 .236.108.374.857a4.372 4.372 0 003.1 3.112c.65.167 3.939.551 3.318 1.969-.148.345-1.969.807-4.431.542a11.884 11.884 0 01-2.737-.758 5.278 5.278 0 01-1.566-1.251l-.473.433-2.826-1.231s.315-1.782.561-2.708a1.231 1.231 0 01.985-.985 14.216 14.216 0 01.345-2.028 1.5 1.5 0 01-.108-.158c.492-6.893 1.162-18.088 3.082-26.418a15.7 15.7 0 011.438-3.692 18.577 18.577 0 001.073-2.324 34.642 34.642 0 01-6.577.118 21.28 21.28 0 01-.079 2.206c-.443 9.846-2.078 24.537-1.841 36.2a2.461 2.461 0 01-.542.315 14.325 14.325 0 01-.069 1.713h.128c.4-.1.246.069.522.778a4.323 4.323 0 003.594 2.521c.67.059 3.939-.128 3.6 1.378-.089.364-1.792 1.132-4.273 1.3a11.812 11.812 0 01-2.826-.266 5.228 5.228 0 01-1.763-.985l-.384.512-2.945-.733s0-1.8.079-2.767a1.221 1.221 0 01.768-1.152 15.754 15.754 0 010-2.2 9.027 9.027 0 01-.847-.315c-.738-8.015-5.179-26.113-2.954-36.284a15.55 15.55 0 01.63-2.225c-8.31 1.1-15.469 2.137-23.021-.364a3.81 3.81 0 01-1.792-1.172H156.7a46.104 46.104 0 01-.985 3.761c-2.452 8.862-7.375 22.647-10.585 30.524z"
              fill="#595959"
              opacity={0.2}
            />
          </g>
          <path
            data-name="Path 9290"
            d="M139.573 288.108a28.4 28.4 0 01-.158 3.466c-.187.906-3.111.61-3.387.1s.069-4.736.069-4.736"
            fill="#ed9c80"
          />
          <path
            data-name="Path 9291"
            d="M135.182 292.548c-.079.985-.079 2.767-.079 2.767l2.954.719.384-.512a5.258 5.258 0 001.753.985 11.9 11.9 0 002.826.266c2.481-.158 4.185-.935 4.273-1.3.355-1.507-2.954-1.319-3.6-1.379a4.333 4.333 0 01-3.6-2.518c-.276-.709-.108-.876-.522-.778a.985.985 0 00-.64.453 1.792 1.792 0 01-1.89.807 2.156 2.156 0 01-1.132-.65 1.231 1.231 0 00-.727 1.14z"
            fill="#3a3a3a"
          />
          <path
            data-name="Path 9292"
            d="M107.189 236.581c-1.182 2.747-1.969 7.7-.768 9.846.985 1.861 1.526 3.013 3.3 3.6 7.542 2.5 14.7 1.467 23.011.364-3.515 9.512 1.585 29.874 2.373 38.509 3.2 1.418 5-.089 5-.089-.354-17.576 3.555-42.123 1.191-46.278-1.447-2.55-18.649-5.908-18.994-5.908"
            fill="#243a6c"
          />
          <path
            data-name="Path 9293"
            d="M120.373 187.772c-.148-.61-1.083-.65-1.507-.2a2.629 2.629 0 00-.5 1.753 4.155 4.155 0 00.758 2.206c.4.65.985 1.034 1.566.492a1.969 1.969 0 01-1.644 2.087 1.822 1.822 0 01-1.8-1.241c-3.407 1.251-4.48-3.683-4.687-6.144a10.152 10.152 0 011.536-5.908 4.185 4.185 0 012.462-1.851 3.938 3.938 0 012.107-2.954 10.28 10.28 0 013.3-1.152c.758-.158 2.826.4 3.21 1.172 1.447-.827 2.737 0 3.88.108s2.432 1.2 1.969 2.245a2.757 2.757 0 013.21 3.308 2.954 2.954 0 01-4.588 1.29 3.456 3.456 0 01-3.161 1.851 6.715 6.715 0 01-3.6-1.251 2.728 2.728 0 01.128 2.353c-.354.778-.64 1.359-1.792 1.123 0 0 .1 1.782-.305 1.615s-.542-.902-.542-.902z"
            fill="#0b0b3a"
          />
          <path
            data-name="Path 9294"
            d="M143.365 232.13c-4.579-6.607-7.03-11.816-11.018-18.787l-5.554-13.785 2.235.138a16.808 16.808 0 014.628.876 9.63 9.63 0 015.356 4.3c.926 1.851 1.487 3.87 2.265 5.78.876 2.137 1.8 4.244 2.737 6.361 1.851 4.185 3.742 8.369 5.307 12.672"
            fill="#0094bc"
          />
          <path
            data-name="Path 9295"
            d="M133.114 214.702l.748-4.47 5.484 12.023-1.812.443z"
            fill="#070707"
            opacity={0.2}
          />
          <path
            data-name="Path 9296"
            d="M106.204 205.88a136.382 136.382 0 00.591 25.748 56.8 56.8 0 001.122 7.07c.069.3.571.246.542-.069-.187-2.107-.561-4.195-.817-6.292s-.482-4.293-.65-6.44q-.5-6.351-.443-12.712c0-2.432.089-4.874.217-7.306a.281.281 0 00-.561 0z"
          />
          <path
            data-name="Rectangle 1263"
            fill="#aabde2"
            d="M113.648 237.802h42.379v1.526h-42.379z"
          />
          <path
            data-name="Path 9297"
            d="M163.578 239.279h-33.92l6.085-19.821a2.6 2.6 0 012.491-1.841h29.707a1.694 1.694 0 011.615 2.186z"
            fill="#aabde2"
          />
          <path
            data-name="Path 9298"
            d="M164.002 239.279h-33.409l6.085-19.821a2.6 2.6 0 012.491-1.841h29.707a1.684 1.684 0 011.615 2.186l-5.828 18.994a.689.689 0 01-.661.482z"
            fill="#e1e8f9"
          />
          <g data-name="Group 470">
            <path
              data-name="Path 9299"
              d="M111.167 209.464c1.753 7.877 2.481 17.015 2.954 22.647 6.548.482 8.389 2.954 14.386 5.672 0 0 4.746-.788 5.238.985.3 1.034-5.544 1.851-5.544 1.851-5.563 0-19.043-2.58-20.038-2.846s-5.071-20.382-5.189-30.524a6.272 6.272 0 01.985-4.116 5.337 5.337 0 011.812-1.339 25.227 25.227 0 0111.2-2.836"
              fill="#070707"
              opacity={0.2}
            />
          </g>
          <path
            data-name="Path 9300"
            d="M127.699 239.023a3.515 3.515 0 012.954-.926 20.686 20.686 0 012.275.2c.354 0 .768.128.8.512s-1.713 0-2.639.266a45.55 45.55 0 005.435.148 1.655 1.655 0 01.62.069.522.522 0 01.354.473.65.65 0 01-.246.414 3.742 3.742 0 01-1.871.758 14.455 14.455 0 01-8.251-.729"
            fill="#ed9c80"
          />
          <path
            data-name="Path 9301"
            d="M111.343 209.474c.148 8.438 1.359 16.109 1.191 24.557 6.548.482 9.846 1.753 15.882 4.421a3.19 3.19 0 01-.2 2.2c-.463.167-19.6-.64-21.18-2.087-1.408-1.3-3.939-21.14-4.047-31.262a6.272 6.272 0 01.985-4.116 5.336 5.336 0 011.812-1.339 25.227 25.227 0 0111.2-2.836"
            fill="#0094bc"
          />
          <path
            data-name="Path 9302"
            d="M130.643 187.368s1.969 3.545 1.7 4-2.678 0-2.678 0"
            fill="#ed9c80"
          />
          <path
            data-name="Path 9303"
            d="M148.612 227.975a3.535 3.535 0 101.032-2.506 3.535 3.535 0 00-1.032 2.506z"
            fill="#fff"
          />
          <path
            data-name="Path 9304"
            d="M323.997 193.779a92.142 92.142 0 005.15-12.5 3.821 3.821 0 01-1.26-.305c-5.356-3.1-4.864 2.412-4.106 4.49.256.709.837 1.6.985 1.969a18.572 18.572 0 01-.128 2.373 1.27 1.27 0 00.571.985 12.447 12.447 0 01-.9 2.284 1.575 1.575 0 00-.315.709zm1.792-5.071a.617.617 0 000-.1v.148a.414.414 0 010-.048zm-13.6 21.662c-2.107.522-2.826 0-2.826 0a43.132 43.132 0 00-4.136-1.575c-1.1-.384-2.521-.985-4.017-1.585l-21.721-21.928-1.822-1.753a9.12 9.12 0 000-1.6c-.138-1.969-.935-5.258-4.46-6.341s-6.164.286-8.685-.67l-3.358-2.954-.128-.2v.1c1.221 5.652.985 17.665 11.442 17.054l1.664 1.684 10.831 10.9c1.142 2.147 4.244 4.362 4.5 4.539l14.3 14.435a88.731 88.731 0 009.718-10.358l-1.221.315z"
            opacity={0.2}
          />
          <path
            data-name="Path 9305"
            d="M307.042 335.597c0 1.241 13.913 2.245 31.075 2.245s31.066-.985 31.066-2.245-13.913-2.245-31.066-2.245-31.075 1.004-31.075 2.245z"
            fill="#afe1f2"
          />
          <path
            data-name="Path 9306"
            d="M332.81 207.168a2.806 2.806 0 01-.906 1.566 3.259 3.259 0 01-1.851.847c-1.831.187-4.657.581-7.651.985-4.8.64-10.024 1.3-12.229 1.182a11.55 11.55 0 01-3.889-.542h-.118c-.325-.286-.335-1.063-.236-1.831s.305-1.684.325-1.91a3.771 3.771 0 013.033-3.269 3.417 3.417 0 01.5-.1l.335-.108c4.5-1.428 9.59-1.782 12.869-2.334a10.831 10.831 0 014.746.246 9.679 9.679 0 012.954 1.369c1.379.907 2.492 2.237 2.118 3.899z"
            fill="#35aad3"
          />
          <path
            data-name="Path 9307"
            d="M310.783 209.316a3.359 3.359 0 01-.453.857 4.022 4.022 0 01-.276.3 4.175 4.175 0 01-3.328.866l-.414-.138-.138-.059c-2.875-1.221-8.98-5.691-13.145-8.862-2.491-1.92-4.293-3.358-4.293-3.358l.374-.571 1.477-2.166s9.266 4.382 13.647 5.908a28.554 28.554 0 015.1 2.078 5.639 5.639 0 01.473.315 5.268 5.268 0 01.976 4.83z"
            fill="#35aad3"
          />
          <path
            data-name="Path 9308"
            d="M322.422 210.558c-4.8.64-10.024 1.3-12.229 1.182a11.55 11.55 0 01-3.889-.542h-.118c-2.875-1.221-8.98-5.691-13.145-8.862.6.364 8.5 4.923 12.909 7.05a14.635 14.635 0 002.491.985 9.01 9.01 0 001.634.148h.246a11.816 11.816 0 009.915-5.7 21.576 21.576 0 011.969-2.668s.125 4.907.217 8.407z"
            fill="#2496b5"
          />
          <path
            data-name="Path 9309"
            d="M308.322 203.615s.719.522 2.826 0-.108 2.058-.108 2.058l-3.318-.207-.276-.857z"
            fill="#35aad3"
          />
          <path
            data-name="Path 9310"
            d="M341.889 227.788a12.475 12.475 0 00-.561 7.247c1.063 4.805-.148 5.12-.148 5.12a62.059 62.059 0 01-11.934 5.829c-3.88 1.2-7.188.985-7.089-3.289v-.807c.177-9.63-1.822-10.122-2.324-20.9-.512-11.067-.394-17.615 3.141-19.4 3.86-1.969 9.177-3.279 16.739-1.5 5.652 1.329 7.523 2.826 7.473 7.021a34.007 34.007 0 01-.61 5.15 93.225 93.225 0 01-4.687 15.528z"
            fill="#35aad3"
          />
          <path
            data-name="Path 9311"
            d="M341.888 227.788a12.475 12.475 0 00-.561 7.247c1.063 4.805-.148 5.12-.148 5.12a62.06 62.06 0 01-11.934 5.829l-5.051-.482-2.028-1.6v-2.018a37.674 37.674 0 007.641-.2 32.031 32.031 0 007.493-1.881 2.954 2.954 0 001.841-3.239 41.9 41.9 0 01-.7-6.725 35.184 35.184 0 011.8-8.281 16.8 16.8 0 00.67-6.134 55.2 55.2 0 010-6.981l4.007-2.176 2.235.837a34.007 34.007 0 01-.611 5.15 93.23 93.23 0 01-4.654 15.534z"
            fill="#2496b5"
          />
          <path
            data-name="Path 9312"
            d="M323.771 188.377c.738.3.433 2.806.571 3.614s.719 3.939 2.373 4.431 2.678.61 2.678.886a9.993 9.993 0 01-.079 1.27 2.983 2.983 0 01-.049.679c-.049.2 0 .118 0 .158a.316.316 0 000 .128 3.25 3.25 0 00.148 1.172l1.083.719a.857.857 0 00.561.3l1.142.089a.68.68 0 00.246 0l.64-.187c.089-.384.148-.679.158-.689s2.028-1.339 3.19-2.107a26.825 26.825 0 01.256-2.954c.069-.3.926-1.969 1.812-3.939l.217-.5c.2-.443.384-.9.571-1.349a.57.57 0 00.079-.177 13.942 13.942 0 001.142-4.244c0-2.895-.1-5.908-1.891-7.414s-13.007-6.8-13.381 1.92a.888.888 0 010 .158 40.378 40.378 0 01-1.969 5.908 1.388 1.388 0 00.5 2.137z"
            fill="#ed9c80"
          />
          <path
            data-name="Path 9313"
            d="M329.383 200.71l.108.542a.807.807 0 00.807.65l1.92-.079a.5.5 0 00.2 0l.64-.187c.089-.384.148-.679.158-.689s2.028-1.339 3.19-2.107a26.8 26.8 0 01.256-2.954c.069-.3.926-1.969 1.812-3.939l.217-.5c.2-.443.384-.9.571-1.349a.806.806 0 00.059-.374l-.079-.867a.778.778 0 00-.7-.719c-.985-.108-2.649-.3-2.737-.286a12.515 12.515 0 00-1.162 2.117c0 .089.483 1.546.611 1.969a1.4 1.4 0 010 .2c0 .443.079 2.255 0 3.939a3.328 3.328 0 01-1.713 2.826l-.148.079a28.471 28.471 0 01-4.008 1.733z"
            fill="#f29d77"
          />
          <path
            data-name="Path 9314"
            d="M323.289 189.17c-2.4 2.186.207 6.893.985 7.6s6.3 2.353 9.472-.7a5.908 5.908 0 001.359-1.969 10.959 10.959 0 00.748-4.342l.906.226a25.022 25.022 0 01-.158 4.559.788.788 0 001.329.571c1.438-1.408 3.614-4.49 4.352-10.683 1.132-9.512-8.4-10.162-10.546-9.945-1.536.167-4.185.079-4.923-.335-5.366-3.092-4.864 2.422-4.106 4.5a18.275 18.275 0 00.985 1.92 18.866 18.866 0 01-.138 2.383 1.3 1.3 0 00.581.985s.541-1.782.61-2.038.276-.985.374-1.339a.374.374 0 01.217-.236 4.144 4.144 0 01.67-.187 23.137 23.137 0 012.816-.236 1.29 1.29 0 011.359 1.231c.128 2.954 1.654 3.515 2.353 3.6a.413.413 0 01.374.374c.463 3.624-.926 5.652-1.526 5.75s-2.511-1.507-2.511-1.507-3.18-2.377-5.582-.182z"
            fill="#0b0b3a"
          />
          <path
            data-name="Path 9315"
            d="M335.557 187.349s.148-1.625 1.4-1.4c1.477.266 2.215 3.722-.069 4.559a.778.778 0 01-1.034-.729 11.2 11.2 0 00-.3-2.432z"
            fill="#f29d77"
          />
          <path
            data-name="Path 9316"
            d="M328.221 204.088s-5.908 19.24-4.7 28.456l2.166 3.939 2.363-4.293s-1.92-18.423 1.763-27.777z"
            fill="#16405a"
          />
          <path
            data-name="Path 9317"
            d="M327.818 202.453v.256a5.112 5.112 0 00.374 1.378l1.6.325 1.379-.985-1.585-1.851-.246.069a3.407 3.407 0 00-1.526.827z"
            fill="#103649"
          />
          <path
            data-name="Path 9318"
            d="M336.443 198.042a18.714 18.714 0 011.162 1.615 13.164 13.164 0 00-2.019.985c-.827.5-4.805 3.318-4.805 3.318l-1.172-2.412s4.589-2.876 6.834-3.506z"
            fill="#2496b5"
          />
          <path
            data-name="Path 9319"
            d="M329.609 201.537a3.348 3.348 0 00-1.822 1.516s-.679-2.058-.108-3.19a3.112 3.112 0 011.654-1.585z"
            fill="#2496b5"
          />
          <path
            data-name="Path 9320"
            d="M323.406 329.147a6.971 6.971 0 00-.483 2.343c.069.985 3.033.985 3.377.522s.522-4.756.522-4.756"
            fill="#feaf84"
          />
          <path
            data-name="Path 9321"
            d="M327.088 332.82a19.271 19.271 0 01-.276 2.55h-3.417l-.167-.571a5.328 5.328 0 01-1.969.571h-2.885c-2.107 0-3.308-.266-3.358-.64-.226-1.556 2.294-1.477 2.954-1.477 1.891 0 3.939-.886 4.372-1.841.325-.7.177-.866.571-.738a.984.984 0 01.591.5 1.723 1.723 0 001.772.985 2.117 2.117 0 001.162-.561 1.251 1.251 0 01.65 1.222z"
            fill="#3a3a3a"
          />
          <path
            data-name="Path 9322"
            d="M356.629 325.927a28.362 28.362 0 001.034 3.338c.414.837 3.19-.187 3.328-.768s-1.28-4.608-1.28-4.608"
            fill="#feaf84"
          />
          <path
            data-name="Path 9323"
            d="M362.019 328.97c.364.906.9 2.649.9 2.649l-2.54 1.546-.512-.384a5.023 5.023 0 01-1.359 1.418 11.164 11.164 0 01-2.56 1.063c-2.363.542-4.195.276-4.382-.049-.778-1.359 2.353-2.107 2.954-2.343a4.214 4.214 0 002.609-3.446c0-.768-.158-.876.256-.906a.985.985 0 01.729.256 1.733 1.733 0 001.969.246 2.068 2.068 0 00.866-.985 1.241 1.241 0 011.073.935z"
            fill="#3a3a3a"
          />
          <path
            data-name="Path 9324"
            d="M344.625 259.336s4.648-11.107-3.446-19.181c0 0-6.893 3.092-12.436 3.466a27.263 27.263 0 01-6.568-.158 101.264 101.264 0 00-1.179 21.416z"
            fill="#243a6c"
          />
          <path
            data-name="Path 9325"
            d="M327.227 330.22h-.414a23.8 23.8 0 01-4.52-.305v-.84c.158-12.712-1.379-33.478-1.674-40.075a7.3 7.3 0 010-1.25c.492-4.815 5.465-4.185 7.552.236a17.012 17.012 0 011.182 3.4 30.274 30.274 0 01.768 4.805c1.016 11.028-2.047 25.798-2.894 34.029z"
            fill="#243a6c"
          />
          <path
            data-name="Path 9326"
            d="M335.843 264.456a2.041 2.041 0 01-.079.414c-1.1 5.79-4.667 21.436-6.371 26.516a3.072 3.072 0 01-2.186 1.6c-2.5.679-6.233-.256-6.548-5.238a12.382 12.382 0 010-1.8c.207-2.6.394-13.706.345-21.091a29.716 29.716 0 011.054-7.493c.167-2.166.561-5.317 1.694-5.711 5.71-1.957 13.577 4.709 12.091 12.803z"
            fill="#243a6c"
          />
          <path
            data-name="Path 9327"
            d="M330.162 296.201c.985 10.979-2.087 25.827-2.954 34.019h-.414s.709-12.987 1.871-21.987a35.732 35.732 0 00-1.477-15.242c-.236-.7-.394-1.083-.394-1.083l1.4-3.939c1.566-5.1 1.6-16.995 1.6-16.995-3.8-8.379-4.332-18.935-4.332-18.935l3.249.453 5.819 6.981 1.231 5.406c-1.1 5.79-4.667 21.436-6.371 26.516a30.258 30.258 0 01.772 4.806z"
            fill="#1c3059"
          />
          <path
            data-name="Path 9328"
            d="M330.535 287.526a28.063 28.063 0 00-.374 8.7c.61 4.293-2.058-3.791-2.058-3.791l1.418-2.954z"
            fill="#1c3059"
          />
          <path
            data-name="Path 9329"
            d="M347.175 287.674c-3.85-3.623-9.206-1.91-6.705 3.712 2.678 5.987 10.949 22.726 15.439 34.6l.305.778a24.555 24.555 0 004.7-1.526c-2.137-7.72-3.683-21.032-8.123-30.307a25.205 25.205 0 00-5.612-7.257z"
            fill="#243a6c"
          />
          <path
            data-name="Path 9330"
            d="M325.484 252.079c-.748-8.95 10.4-3 15.754-.059 2.255 1.25 3.072 3.732 3.377 6.075s3.19 26.448 3.771 30.849c1.31 9.906-7.355 4.49-8.173 1.743-2.066-6.942-14.295-33.685-14.729-38.608z"
            fill="#243a6c"
          />
          <path
            data-name="Path 9331"
            d="M347.579 282.79s.354 4.746 4.342 10.595c0 0-6.528-3-6.843-3.446a24.489 24.489 0 01-1.329-5.534c.158-.483 3.83-1.615 3.83-1.615z"
            fill="#243a6c"
          />
          <path
            data-name="Path 9332"
            d="M336.749 243.69l.5.443s3.939-3.427 7.021-6.321c2.846-2.7 5.74-5.711 7.542-9.315a4.929 4.929 0 00.246-.512 1.2 1.2 0 00.079-.315.988.988 0 000-.177 1.07 1.07 0 000-.187v-.532a2.406 2.406 0 000-.266 17.464 17.464 0 00-.217-2.59c-.325-3.555-3.84-14.691-5.041-19.338a3.141 3.141 0 00-1.093-1.713 2.806 2.806 0 00-1.664-.66h-.286c.738 1.191 1.792 3.6 2.954 8.429 1.566 6.44 2.668 10.339 3.111 12.8a8.567 8.567 0 01.2 2.688 8.125 8.125 0 01-1.123 2.344c-2.54 4.489-9.413 13.289-12.229 15.222z"
            fill="#2496b5"
          />
          <path
            data-name="Path 9333"
            d="M271.516 182.081c4.067-2.806 5.15-5.347 5.15-5.347a9.127 9.127 0 000-1.6c-.148-1.969-.935-5.268-4.46-6.351-5.209-1.585-8.31 2.058-12.17-3.86v.1c1.249 5.655 1.033 17.678 11.48 17.058z"
            fill="#fff"
          />
          <path
            data-name="Path 9334"
            d="M271.516 182.081c4.067-2.806 5.15-5.347 5.15-5.347a9.117 9.117 0 000-1.6c-11.146 11.737-16.247-8.576-16.611-10.112 1.231 5.657 1.014 17.679 11.461 17.059z"
            fill="#ffe7c5"
          />
          <g data-name="Group 471">
            <path
              data-name="Path 9335"
              d="M260.064 165.027a10.959 10.959 0 003.564 4.234 8.221 8.221 0 002.452 1.241 12.406 12.406 0 002.737.4 11.549 11.549 0 012.846.443 5.622 5.622 0 012.432 1.625 5.426 5.426 0 011.211 2.629 6.007 6.007 0 01-.286 2.836 5.681 5.681 0 00-1.29-5.13 5.317 5.317 0 00-2.245-1.428 16.094 16.094 0 00-2.727-.4 12.957 12.957 0 01-2.836-.482 8.586 8.586 0 01-2.521-1.418 10.1 10.1 0 01-3.338-4.549z"
              fill="#ffe7c5"
            />
          </g>
          <g data-name="Group 472">
            <path
              data-name="Path 9336"
              d="M260.064 165.027a17.725 17.725 0 002.334 4.687 12.279 12.279 0 003.761 3.505 19.484 19.484 0 002.393 1.044 12.229 12.229 0 012.373 1.27 6.352 6.352 0 011.851 1.969 5.337 5.337 0 01.65 2.58 5.672 5.672 0 00-2.777-4.155 12.031 12.031 0 00-2.3-1.162 13.145 13.145 0 01-2.462-1.073 11.442 11.442 0 01-3.82-3.761 14.339 14.339 0 01-2.003-4.904z"
              fill="#ffe7c5"
            />
          </g>
          <path
            data-name="Path 9337"
            d="M352.306 262.113a2.522 2.522 0 01-.807-.128c-3.092-.985-4.264-7.789-4.392-8.566l-.138-.876.857.226c.758.2 7.454 2.028 8.251 5.091a2.954 2.954 0 01-1.063 2.885 4.007 4.007 0 01-2.708 1.369zm-3.88-7.966c.473 2.265 1.654 6.154 3.436 6.735.679.217 1.467-.108 2.334-.985a1.831 1.831 0 00.758-1.772c-.482-1.743-4.293-3.279-6.528-3.978z"
            fill="#0b0b3a"
          />
          <path
            data-name="Rectangle 1264"
            fill="#ffc25b"
            d="M273.177 183.782l5.271-5.226 72.216 72.831-5.27 5.227z"
          />
          <path
            data-name="Rectangle 1265"
            fill="#ffa92c"
            d="M271.347 181.947l5.271-5.226 1.823 1.838-5.27 5.227z"
          />
          <path
            data-name="Rectangle 1266"
            fill="#ff8736"
            d="M273.177 183.782l5.271-5.226 72.216 72.831-5.27 5.227z"
          />
          <path
            data-name="Rectangle 1267"
            fill="#0b0b3a"
            d="M271.347 181.947l5.271-5.226 1.823 1.838-5.27 5.227z"
          />
          <path
            data-name="Path 9338"
            d="M350.641 251.41l-2 1.979-72.183-72.864-1.822-1.831-3.289 3.239 5.278-5.228 1.822 1.831z"
            fill="#ffc25b"
          />
          <path
            data-name="Rectangle 1268"
            fill="#0b0b3a"
            d="M344.358 255.624l5.271-5.226 1.019 1.027-5.271 5.226z"
          />
          <path
            data-name="Path 9339"
            d="M338.59 243.05l-3.112-2.59s-.916 1.516-1.585 1.723a4.826 4.826 0 01-.827-.089 5.415 5.415 0 00-2.511.778c-.729.335-1.694.64-1.733.926s.473.758.985.719a.983.983 0 00.246 0 1.616 1.616 0 00.059.305c.217.66 3.269 4.923 6.3.286a8.519 8.519 0 012.178-2.058z"
            fill="#ffbc9f"
          />
          <path
            data-name="Path 9340"
            d="M340.156 212.693c1.034 3.161 2.127 8.153 4.195 12.387 0 .1.089.187.128.266v.049a3.548 3.548 0 00.148.473 3.791 3.791 0 003.692 2.531h2.324a1.78 1.78 0 001.388-.482 1.2 1.2 0 00.079-.315.977.977 0 000-.177 1.058 1.058 0 000-.187v-.532a2.4 2.4 0 000-.266 17.459 17.459 0 00-.217-2.59c-.325-3.555-3.84-14.691-5.041-19.338a3.141 3.141 0 00-1.093-1.713 2.806 2.806 0 00-1.664-.66h-.289c-1.566 0-2.629 1.27-3.348 2.737a9.52 9.52 0 00-.926 3.082 11.047 11.047 0 00.624 4.735z"
            fill="#35aad3"
          />
          <path
            data-name="Path 9341"
            d="M334.661 241.573l2.1 2.117.5.443s3.939-3.427 7.021-6.321c2.846-2.7 5.74-5.711 7.542-9.315a4.926 4.926 0 00.246-.512 1.2 1.2 0 00.079-.315.985.985 0 000-.177 1.064 1.064 0 000-.187v-.532a2.392 2.392 0 000-.266 3.23 3.23 0 00-.719-2.078l-.148-.167a3.366 3.366 0 00-.768-.561 4.1 4.1 0 00-.581-.246 5.475 5.475 0 00-4.4.6l-.374.394a11.122 11.122 0 00-.817.985 16 16 0 00-2.117 3.545c-1.744 4.293-7.564 12.593-7.564 12.593z"
            fill="#35aad3"
          />
          <path
            data-name="Path 9342"
            d="M288.501 199.224s-4.736-3.3-4.923-5.819c-.236-2.787 1.723-4.126 2.954-2.59 2.028 2.412 1.487 6.784 1.487 6.784l.453 1.625z"
            fill="#ffd4c5"
          />
          <path
            data-name="Rectangle 1269"
            fill="#ffdc8f"
            d="M383.145 163.107h11.688v13.588h-11.688z"
          />
          <path
            data-name="Path 9343"
            d="M389.82 164.505a.817.817 0 11-.807-.807.817.817 0 01.807.807z"
            fill="#ff8736"
          />
          <path
            data-name="Rectangle 1270"
            fill="#ffdc8f"
            d="M400.012 158.528H411.7v13.588h-11.688z"
          />
          <path
            data-name="Path 9344"
            d="M406.658 159.929a.817.817 0 11-.817-.817.817.817 0 01.817.817z"
            fill="#ff8736"
          />
          <path
            data-name="Path 9345"
            d="M261.088 161.138s-4.6-7.473-.985-8.123 1.635 7.02.985 8.123z"
            fill="#fff"
          />
          <path
            data-name="Path 9346"
            d="M262.211 161.138s1.575-5.209 3.7-3.013-3.7 3.013-3.7 3.013z"
            fill="#fff"
          />
          <path
            data-name="Path 9347"
            d="M389.821 84.897s-.985 37.092 30.209 40.538c6.065.591 17.192.305 16.414-8.547-.4-4.667-4.264-10.083-8.694-11.717-3.83-1.418-7.877-2.324-11.619-3.939a9.669 9.669 0 01-4.815-3.742c-1.969-3.377-1.083-7.877-2.511-11.481a20.1 20.1 0 00-7.1-9.059c-4.579-3.23-10.329-3.249-11.629 3.131a27.016 27.016 0 00-.256 4.815z"
            fill="#c3ecfe"
            opacity={0.35}
          />
          <path
            data-name="Path 9348"
            d="M137.309 51.35c-.807.66-1.7 1.231-2.57 1.822-9.334 6.361-17.655 16.936-18.108 28.624-.591 14.967-22.923.64-16.975-20.727s24.863-21.377 30.022-20.685c3.052.4 8.862 1.822 10.014 5.2a4.815 4.815 0 01-1.132 4.539 9.156 9.156 0 01-1.251 1.227z"
            fill="#c3ecfe"
            opacity={0.35}
          />
        </g>
      </g>
    </svg>
  )
}

const MemoSvgComponent = React.memo(SvgComponent)
export default MemoSvgComponent
